import * as Sentry from '@sentry/react';
import { tanstackRouterBrowserTracingIntegration } from '@sentry/react';
import type { AnyRouter } from '@tanstack/react-router';

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    console.warn('[Sentry] VITE_SENTRY_DSN is not set — Sentry is disabled.');
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    enabled: true,

    // Performance monitoring — router integration added separately via addRouterInstrumentation()
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,

    // Session replay (10% of sessions, 100% of error sessions)
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
  });
}

/**
 * Call this after the TanStack Router instance is created to enable
 * route-aware performance tracing (route names in spans, navigation events).
 */
export function addRouterInstrumentation(router: AnyRouter) {
  Sentry.addIntegration(tanstackRouterBrowserTracingIntegration(router));
}

export { Sentry };
